import { BlockDto, BlockTypeEnum, BtzBtnStatusEnum, BtzDto, VariantDto } from "@rsmu/oep-api";
import { QuizButtonStatusEnum } from "./enums/quiz-button-status.enum";
import { QuizVariantInterface } from "./interfaces/quiz-variant.interface";

export class OepQuiz {
    quizButtonStatus?: QuizButtonStatusEnum;
    recievedVariants?: number;
    avaliableVariants?: number;
    testTime?: number;
    showBestResult?: boolean;
    currentVariant?: QuizVariantInterface;
    bestResult?: QuizVariantInterface;
    results?: Array<QuizVariantInterface | undefined>;


    constructor(
        quizButtonStatus?: QuizButtonStatusEnum,
        recievedVariants?: number,
        avaliableVariants?: number,
        testTime?: number,
        showBestResult?: boolean,
        currentVariant?: QuizVariantInterface,
        bestResult?: QuizVariantInterface,
        results?: QuizVariantInterface[]) {
            this.quizButtonStatus = quizButtonStatus;
            this.recievedVariants = recievedVariants;
            this.avaliableVariants = avaliableVariants;
            this.testTime = testTime;
            this.showBestResult = showBestResult;
            this.currentVariant = currentVariant;
            this.bestResult = bestResult;
            this.results = results;
    }

    static mapIomDtoBtzToQuiz (btzDto?: BtzDto): OepQuiz | undefined {
        if(!btzDto) {
            return;
        }
        const oepQuiz: OepQuiz = new OepQuiz(
            OepQuiz.mapBtnStatusEnumToQuizButtonStausEnum(btzDto.btnStatus),
            btzDto.variantReceived,
            btzDto.variantCount,
            btzDto.testTime,
            btzDto.showBestResult,
            OepQuiz.mapVariantDtoToQuizVariant(btzDto.currentVariant),
            OepQuiz.mapVariantDtoToQuizVariant(btzDto.bestVariant),
        )
        return oepQuiz;
    }

    static mapBtnStatusEnumToQuizButtonStausEnum (btnStatus?: BtzBtnStatusEnum): QuizButtonStatusEnum {
        switch (btnStatus) {
            case BtzBtnStatusEnum.GENERATE_NEW: {
                return QuizButtonStatusEnum.Generate;
            }
            case BtzBtnStatusEnum.GO: {
                return QuizButtonStatusEnum.Go;
            }
            case BtzBtnStatusEnum.VIEW_PROTOCOL: {
                return QuizButtonStatusEnum.ViewProtocol;
            }
            case BtzBtnStatusEnum.DISABLE: {
                return QuizButtonStatusEnum.Disable;
            }
            default: {
                return QuizButtonStatusEnum.Generate;
            }
        }
    }

    static mapVariantDtoToQuizVariant(variantDto?: VariantDto): QuizVariantInterface | undefined {
        if(!variantDto) {
            return;
        }
        let variant: QuizVariantInterface;
        variant = {
            id: variantDto.id || '',
            title: variantDto.title || '',
            startTime: variantDto.startTime,
            endTime: variantDto.endTime,
            finishTime: variantDto.finishTime,
            examTime: variantDto.examTime,
            mark: variantDto.mark,
            passed: variantDto.passed,
            positiveCount: variantDto.positiveCount,
            totalCount: variantDto.totalCount,
            correctPercent: variantDto.correctPercent,
            iomQtId: variantDto.targetId,
            code: variantDto.code,
            showThemeProtocol: variantDto.showThemeProtocol,
            timeWasSpent: variantDto.timeWasSpent
        }
        return variant;
    }

    static mapBlockDtoToOepQuiz (blockDto: BlockDto): OepQuiz | undefined {

        let quiz: OepQuiz | undefined = undefined;
        if(blockDto) {
            quiz = new OepQuiz(
                OepQuiz.mapBtnStatusEnumToQuizButtonStausEnum(blockDto.btz?.btnStatus),
                blockDto.btz?.variantReceived,
                blockDto.btz?.variantCount,
                blockDto.btz?.testTime,
                blockDto.btz?.showBestResult,
                OepQuiz.mapVariantDtoToQuizVariant(blockDto.btz?.currentVariant),
                OepQuiz.mapVariantDtoToQuizVariant(blockDto.btz?.bestVariant),
            );
            if(blockDto.btzResults) {
                quiz.results = blockDto.btzResults?.map(result => OepQuiz.mapVariantDtoToQuizVariant(result));
            }
        }
        return quiz
    }

}
